import {
    useEffect, useState, useRef, RefObject,
} from 'react'
import debounce from 'lodash/debounce'

export default function useContainerSize(ref: RefObject<HTMLElement>, delay = 100) {
    const [
        size,
        setSize,
    ] = useState({
        width: 0, height: 0,
    })
    const observerRef = useRef<ResizeObserver | null>(null)

    useEffect(() => {
        const element = ref.current

        if (!element) return

        const handleResize = debounce((entry: ResizeObserverEntry) => {
            const {
                width, height,
            } = entry.contentRect

            setSize({
                width, height,
            })
        }, delay)

        observerRef.current = new ResizeObserver((entries) => {
            const [entry] = entries

            if (entry) handleResize(entry)
        })

        observerRef.current.observe(element)

        // eslint-disable-next-line consistent-return
        return () => {
            observerRef.current?.disconnect()
            handleResize.cancel() // important to clean up debounce
        }
    }, [
        ref,
        delay,
    ])

    return size
}
